import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const HowToOrderItemWrapper = styled.div`
	display: flex;
	column-gap: 40px;

	${breakpoints.to.desktop} {
		flex-direction: column;
		row-gap: 40px;
	}

	${breakpoints.to.tablet} {
		row-gap: 24px;
	}
`;
export const HowToOrderItemContent = styled.div`
	display: flex;
	flex-direction: column;
`;
export const contentItemTextStyles = css`
	&:first-of-type {
		margin-top: 16px;
	}

	&:last-of-type {
		margin-bottom: 32px;
	}

	& + & {
		margin-top: 8px;
	}

	${breakpoints.to.tablet} {
		&:first-of-type {
			margin-top: 12px;
		}
	}
`;
export const contentItemButtonStyles = css`
	width: max-content;
	margin-top: auto;

	${breakpoints.to.tablet} {
		width: 100%;
	}
`;
export const pictureStyles = css`
	min-height: 295px;
`;
export const imgStyles = css`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 4px;
`;
export const HowToOrderSection = styled.section`
	margin-top: 80px;
`;
